import { render } from "./SeoFilesEditor.vue?vue&type=template&id=56280668&scoped=true"
import script from "./SeoFilesEditor.vue?vue&type=script&lang=js"
export * from "./SeoFilesEditor.vue?vue&type=script&lang=js"

import "./SeoFilesEditor.vue?vue&type=style&index=0&id=56280668&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56280668"]])

export default __exports__